import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  { name: 'miProductType', label: 'Product Type' },
  { name: 'miPaymentType', label: 'Payment Type' },
  { name: 'miRenewalType', label: 'Renewals' },
  { name: 'miRefundable', label: 'Refundable' },
  { name: 'miFinanced', label: 'Financed MI' },
  { name: 'miUpfrontPremiumPercent', label: 'Upfront Premium %' },
  { name: 'miCompanyType', label: 'MI Company' },
  { name: 'miCompanyOtherDescription', label: 'Other MI Company Name' },
  { name: 'miApplicationType', label: 'Application Type' },
  { name: 'miOrderStatus', label: 'Order Status' },
  { name: 'miDecisionType', label: 'Decision' },
  { name: 'miOrderedDate', label: 'Ordered Date' },
  { name: 'miDecisionDate', label: 'Decision Date' },
  { name: 'miActivatedDate', label: 'Activated Date' },
  { name: 'miCertificateIdentifier', label: 'Certificate Number' },
  { name: 'miCertificateExpirationDate', label: 'Certificate Expiration Date' },
  { name: 'miQuoteIdentifier', label: 'Quote ID' },
  { name: 'miQuoteExpirationDate', label: 'Quote Expiration Date' },
  { name: 'miInitialPremiumRatePercent', label: 'Initial Premium Rate %' },
  { name: 'miInitialPremiumTermMonths', label: 'Initial Premium Term (Months)' },
  { name: 'miRenewalPremiumRatePercent', label: 'Renewal Premium Rate %' },
  { name: 'miRenewalPremiumTermMonths', label: 'Renewal Premium Term (Months)' },
  { name: 'miUpfrontPremiumAmount', label: 'Upfront Premium Amount' },
  { name: 'miPremiumTaxAmount', label: 'Premium Tax Amount' },
].map(field => ({ ...field, levelType: AutoLockFormsLevelType.FIELD }));

export const mortgageInsuranceForm = {
  name: FormNames.MORTGAGE_INSURANCE,
  label: 'Mortgage Insurance',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
